export function parseCloneErrorMessage(error: unknown): string {
  let errorMessage = 'Failed to clone fund opportunity';
  if (error && typeof error === 'object') {
    if ('error' in error && typeof (error as { error: unknown }).error === 'string') {
      errorMessage = (error as { error: string }).error;
    } else if (
      'missingFields' in error &&
      Array.isArray((error as { missingFields: unknown }).missingFields)
    ) {
      errorMessage = `Missing required fields: ${(error as { missingFields: string[] }).missingFields.join(', ')}`;
    } else if (
      'invalidFields' in error &&
      typeof (error as { invalidFields: unknown }).invalidFields === 'object'
    ) {
      const invalidFieldMessages = Object.entries(
        (error as { invalidFields: Record<string, string> }).invalidFields,
      )
        .map(([field, msg]) => `${field}: ${msg}`)
        .join(', ');
      errorMessage = `Invalid fields: ${invalidFieldMessages}`;
    }
  }
  return errorMessage;
}
